const DB_NAME = 'zippax';
const DB_VERSION = 1;
const STORE = 'boards';
const SESSION_KEY = 'zippax.account';

const memory = new Map();

function openDb() {
  if (typeof indexedDB === 'undefined') return Promise.resolve(null);
  return new Promise((resolve) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE);
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => resolve(null);
  });
}

export function readCache(userId) {
  if (!userId) return Promise.resolve(null);
  return openDb().then(
    (db) =>
      new Promise((resolve) => {
        if (!db) {
          resolve(memory.get(userId) || null);
          return;
        }
        const request = db.transaction(STORE, 'readonly').objectStore(STORE).get(userId);
        request.onsuccess = () => resolve(request.result || null);
        request.onerror = () => resolve(memory.get(userId) || null);
      })
  );
}

export function writeCache(userId, record) {
  if (!userId) return Promise.resolve();
  memory.set(userId, record);
  return openDb().then(
    (db) =>
      new Promise((resolve) => {
        if (!db) {
          resolve();
          return;
        }
        const request = db.transaction(STORE, 'readwrite').objectStore(STORE).put(record, userId);
        request.onsuccess = () => resolve();
        request.onerror = () => resolve();
      })
  );
}

export function clearCache(userId) {
  if (!userId) return Promise.resolve();
  memory.delete(userId);
  return openDb().then(
    (db) =>
      new Promise((resolve) => {
        if (!db) {
          resolve();
          return;
        }
        const request = db.transaction(STORE, 'readwrite').objectStore(STORE).delete(userId);
        request.onsuccess = () => resolve();
        request.onerror = () => resolve();
      })
  );
}

export function readSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const user = JSON.parse(raw);
    if (!user || typeof user.id !== 'string') return null;
    return user;
  } catch {
    return null;
  }
}

export function writeSession(user) {
  if (!user?.id) return;
  try {
    localStorage.setItem(
      SESSION_KEY,
      JSON.stringify({
        id: user.id,
        email: user.email,
        name: user.name,
        role: user.role === 'admin' ? 'admin' : 'user',
      })
    );
  } catch {
    /* ignore */
  }
}

export function clearSession() {
  try {
    localStorage.removeItem(SESSION_KEY);
  } catch {
    /* ignore */
  }
}
